/* eslint-disable */
import React, { Component } from 'react';
import { messages } from '../../common/messages';
import config from '../config/App_data';
import { Row, Col, Card, CardHeader } from 'reactstrap';
import GetData from '../RestAPI/getDataService';
import postData from '../RestAPI/fetchData';
import LoaderWrapper from '../../Components-2025/QuestionBank/LoaderWrapper';
import { browserHistory } from 'react-router';
import { examRedirectRoute } from '../Common/examRedirectRoute';
import notFoundImage from '../../assets/img/error_404.svg';
import { formatMoney, formatPrettyDate } from '../../utils/CommonUtils';

export default class WordPressThankYou extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderDetails: {
        paymentMode: '',
        userName: '',
        userEmail: '',
        orderId: '',
        createdAt: null,
        // Every purchased line, not just the first — a multi-package order used
        // to render a single row.
        items: [],
        // The amount actually charged. Authoritative: order_data carries the
        // catalogue price on orders placed before 2026-10-05.
        paidTotal: null,
      },
      isLoading: false,
      isDisabled: false,
      error: false,
    };
  }
  async componentDidMount() {
    const { orderId } = this.props.params;
    this.getOrders(orderId);
  }

  getOrders = async orderId => {
    try {
      this.setState({ isLoading: true });
      const payload = { orderId };
      const orderDetails = await GetData.callAPI(
        `${config.backend_api}/partner/user/order`,
        payload,
      );
      const {
        data: { data = {}, success },
      } = orderDetails;
      if (success) {
        const { orderSubscriptionDetails, paymentMode, userEmail, orderId, amount } = data;
        let orderDetails = null;
        let userName = null;

        if (orderSubscriptionDetails) {
          const parsedOrderData = JSON.parse(orderSubscriptionDetails);
          userName = parsedOrderData.username;
          if (parsedOrderData.all_order_details) orderDetails = parsedOrderData.all_order_details;
        }

        const items = (orderDetails || []).map((item) => {
          const extras = Array.isArray(item.extras) ? item.extras : [];
          const addonsTotal = extras.reduce((sum, e) => sum + (Number(e.price) || 0), 0);
          const basePrice = Number(item.price) || 0;
          // item.price includes add-ons; back out the plan-only figure, exactly
          // as the LMS thank-you page does.
          const planPriceOnly = Math.max(0, basePrice - addonsTotal);
          const pct = Number(item.percent_discount) || 0;

          return {
            // The exam name is the human label. This used to show
            // `package_val` — the tier key — so the page literally read
            // "simple (Practice Subscription)".
            examName: item.exam_name || '',
            packageType: item.package_type || '',
            basePrice,
            planPriceOnly,
            extras,
            percentDiscount: pct,
            // Discount applies to the plan only, never to add-ons.
            discountAmount: pct > 0 ? (planPriceOnly * pct) / 100 : 0,
            // Absence of payment_interval is what marks a one-time package.
            // `monthly_payment` / `subscriptionId` were written incorrectly
            // until 2026-10-05 and are still wrong on historical orders.
            paymentInterval: item.payment_interval || '',
          };
        });

        const orderInformation = {
          paymentMode,
          orderId,
          userName,
          userEmail,
          createdAt: data.createdAt || null,
          items,
          paidTotal: amount != null ? Number(amount) : null,
        };
        this.setState({
          orderDetails: orderInformation,
          isLoading: false,
          ...(!userEmail && { error: true }),
        });
      }
    } catch (error) {
      this.setState({ orderDetails: {}, isLoading: false, error: true });
    }
  };

  redirectToApp = async email => {
    try {
      this.setState({ isDisabled: true });
      const loginDetails = await postData.callAPI(
        `${config.backend_api}/partner/user/getOrganizationDomain`,
        {
          email,
        },
      );
      const {
        user: { success, partnerDomain },
      } = loginDetails;
      if (success && partnerDomain) {
        window.location.href = process.env.REACT_APP_FRONTEND_ENDPOINT.replace(
          'app.',
          `${partnerDomain}.`,
        );
      }
    } finally {
      this.setState({ isDisabled: false });
    }
  };

  render() {
    const { orderDetails, isLoading, error, isDisabled } = this.state;
    const {
      paymentMode = '',
      userName = '',
      userEmail = '',
      orderId = '',
      createdAt = null,
      items = [],
      paidTotal = null,
    } = orderDetails;

    const subtotal = items.reduce((sum, item) => sum + item.basePrice, 0);
    const discountTotal = items.reduce((sum, item) => sum + item.discountAmount, 0);
    const firstPct = (items.find((item) => item.percentDiscount > 0) || {}).percentDiscount || 0;
    const hasDiscount = discountTotal > 0;
    // The charge is the truth; the computed subtotal is only a fallback.
    const total = paidTotal != null ? paidTotal : subtotal - discountTotal;
    const paymentLabel = paymentMode === 'stripe'
      ? 'Credit / Debit Card'
      : (paymentMode || '—');
    const dateText = createdAt ? formatPrettyDate(createdAt) : '';
    return (
      <div className='container'>
        <Row className='justify-content-center'>
          <Col className='col-xs-12 col-sm-12 col-md-12 text-center margin_bottom_20 logo_wrapper'>
            <img src={`${config.frontend_url}/img/logo1.png`} alt='Analystprep logo' width='200' />
          </Col>
          <LoaderWrapper isLoading={isLoading}>
            <Col>
              {!error ? (
                <Card className='col-xs-12 col-sm-12 col-md-12 card-group p-2 mb-0'>
                  <CardHeader className='card-block'>
                    <div className='pb-2'>
                      <h1>
                        <b>{messages.THANK_YOU_FOR_YOUR_ORDER}</b>
                      </h1>
                    </div>
                    <small>{messages.PURCHASE_CONFIRMATION}</small>
                  </CardHeader>
                  <Row>
                    <Col className='col-xs-12 col-sm-6 col-md-7 margin_bottom_10'>
                      <div className='table-responsive thankyou_tb'>
                        <table className='table cart_table '>
                          <thead>
                            <tr>
                              <th>{messages.PACKAGE}</th>
                              <th>{messages.PRICE}</th>
                              {hasDiscount ? <th>{messages.DISCOUNT}</th> : <th />}
                            </tr>
                          </thead>
                          <tbody>
                            {items.map((item, index) => (
                              <tr className='package-heading' key={index}>
                                <td width='60%'>
                                  {item.examName}
                                  {item.packageType ? ` (${item.packageType})` : ''}
                                  {item.extras.map((extra, extraIndex) => (
                                    <div className='text_light' key={extraIndex}>
                                      + {extra.title || 'Add-on'} {formatMoney(extra.price)}
                                    </div>
                                  ))}
                                </td>
                                <td width='20%'>
                                  {formatMoney(item.planPriceOnly)}
                                  {/* A subscription bills per period — without this a
                                      monthly plan read like a one-off purchase. */}
                                  {item.paymentInterval ? ` / ${item.paymentInterval}` : ''}
                                </td>
                                {hasDiscount ? (
                                  <td width='20%'>
                                    {item.percentDiscount > 0
                                      ? `-${item.percentDiscount}% (-${formatMoney(item.discountAmount)})`
                                      : ''}
                                  </td>
                                ) : (
                                  <td width='20%' />
                                )}
                              </tr>
                            ))}
                          </tbody>
                          <tfoot>
                            {hasDiscount ? (
                              <tr>
                                <td>{messages.DISCOUNT}{firstPct > 0 ? ` (-${firstPct}%)` : ''}</td>
                                <td>-{formatMoney(discountTotal)}</td>
                                <td />
                              </tr>
                            ) : null}
                            <tr>
                              <td>
                                <strong>{messages.TOTAL}</strong>
                              </td>
                              <td>
                                <strong>{formatMoney(total)}</strong>
                              </td>
                              <td />
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </Col>
                    <Col className='col-xs-12 col-sm-6 col-md-5 margin_bottom_10'>
                      <div className='table-responsive thankyou_tb'>
                        <table className='table cart_table'>
                          <tbody>
                            {[
                              { label: messages.ORDER_ID, value: orderId },
                              { label: messages.NAME, value: userName },
                              { label: messages.PAYMENT_METHOD, value: paymentLabel },
                              { label: messages.EMAIL, value: userEmail },
                              ...(dateText ? [{ label: 'Date', value: dateText }] : []),
                            ].map(({ label, value }) => (
                              <tr key={label}>
                                <td>
                                  <strong>{label}: </strong>
                                </td>
                                <td>{value}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </Col>
                    <Col className='col-xs-12 col-sm-12 col-md-12 margin_bottom_10 m-0 d-flex justify-content-center'>
                      <button
                        className='btn btn-primary pointer_class'
                        disabled={isDisabled}
                        onClick={() => this.redirectToApp(userEmail)}
                      >
                        {isDisabled && <i className='fa fa-spinner fa-spin mr-1' />}
                        {messages.START_STUDY}
                      </button>
                    </Col>
                  </Row>
                </Card>
              ) : (
                <Row className='justify-content-center'>
                  <Col className='col-sm-6 text-center'>
                    <p className='font-weight-bold  '>{messages.ORDER_NOT_FOUND}</p>
                    <img src={notFoundImage} className='h-100 w-50' />
                  </Col>
                </Row>
              )}
            </Col>
          </LoaderWrapper>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Thankyou/WordPressThankYou.js